import React, { useEffect } from 'react';

export default function Success() {
  useEffect(() => {
    localStorage.removeItem('000003e8-7a8b-21f0-8900-325096b39f47');
  }, []);

  return (
    <div>
      <h2 className={'headline'}>Deine Buchung war erfolgreich</h2>
      <p className={'tw:pb-48'}>
        In Kürze erhälst du Informationen zur weiteren Abwicklung.
      </p>
    </div>
  );
}
